// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-07c2a330]{font-family:Roboto,sans-serif}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/Currency.vue"],"names":[],"mappings":"AAAA,sBAAK,6BAA+B","sourcesContent":["span{font-family:\"Roboto\",sans-serif}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
